import request from "@/utils/request";

// 生成一个完整的AI报告
export function getcreateAiReport(data) {
  return request({
    url: "/ai/aiapi/v1/createAiReport",
    method: "post",
    data: data,
  });
}

// 简单文件上传
export function addBaseFileUpload(data) {
  return request({
    url: "/base/tool/file/v1/simple/upload",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  });
}

// 字典数据-学段列表(t)
export function getBasePhaseList() {
  return request({
    url: `/base/dict/data/v1/phase/list`,
    method: "get",
  });
}

// 字典数据-院系列表(t)
export function getBaseGradeList() {
  return request({
    url: `/base/dict/data/v1/grade/list`,
    method: "get",
  });
}

// 字典数据-课程列表(t)
export function getBaseSubjectList(phaseId) {
  return request({
    url: `/base/dict/data/v1/subject/list?phaseId=${phaseId}`,
    method: "get",
  });
}

// 字典数据-课程列表(t)(数组形式id)
export function getBaseSubjectListByPhaseIds(phaseIds) {
  return request({
    url: `/base/dict/data/v1/subject/listByPhaseIds?phaseIds=${phaseIds}`,
    method: "get",
  });
}

// 字典数据-批量查询课程(t)(数组形式id)
export function baseSubjectListBatch(data) {
  return request({
    url: "/base/dict/data/v1/subject/listBatch",
    method: "post",
    data: data,
  });
}

// 获取当前学校信息
export function getSchoolInfo() {
  return request({
    url: `/base/system/tenant/school/get/current/school/info`,
    method: "get",
  });
}

// 字典数据-管理员-教师列表(t)
export function getBaseTeacherList() {
  return request({
    url: `/base/dict/data/v1/admin/teacher/list`,
    method: "get",
  });
}


// 字典数据-管理员-教师列表(t)带分页查询
export function getAdminTeacherList(data) {
  return request({
    url: `/base/dict/data/v1/admin/teacher/page/list`,
    method: "post",
    data: data,
  });
}

// 字典数据-管理员-教师列表(t)
export function getBaseClassroomList(data) {
  return request({
    url: `/base/dict/data/v1/classroom/list?buildingFloorId=${data}`,
    method: "get",
  });
}

// 获取教室名称
export function sgktTeachingGetRoomNameList(data) {
  return request({
    url: "/app/zhkt/teaching/research/interaction/v1/getRoomNameList",
    method: "post",
    data: data,
  });
}

// 获取全部教室树
export function getClassroomTree(data) {
  return request({
    url: `/base/dict/data/v1/classroom/tree?flag=${data}`,
    method: "get",
  });
}

// 字典数据-教室树(仅查询绑定文香录播设备教室)
export function getRecordClassroomTree() {
  return request({
    url: `/base/dict/data/v1/record/classroom/tree`,
    method: "get",
  });
}

// 修改教师信息
export function updateTea(data) {
  return request({
    url: "/base/user/v1/teacher/update",
    method: "post",
    data: data,
  });
}

// 获取教师信息
export function getTeaInfo(data) {
  return request({
    url: `/base/user/v1/teacher/info?userId=${data}`,
    method: "get",
  });
}
// 校验是否绑定区域
export function getBaseTeacherBindArea() {
  return request({
    url: `/base/system/tenant/school/check/bind/area`,
    method: "get",
  });
}

// 根据用户id查询行政班
export function getClassByUserId(userId) {
  return request({
    url: `/base/class/v1/getClassByUserId?userId=${userId}`,
    method: "get",
  });
}

// 根据用户id查询教学班
export function getCourseClassByUserId(userId) {
  return request({
    url: `/base/course/class/v1/getCourseClassByUserId?userId=${userId}`,
    method: "get",
  });
}

// 用户管理-注册用户完善信息(t)
export function userPerfectInfo(data) {
  return request({
    url: "/base/user/v1/perfect/info",
    method: "post",
    data: data,
  });
}

// 文件下载
export function getFileDownload(accessPath, fileName) {
  return request({
    url: `/base/tool/file/v1/download?accessPath=${accessPath}&fileName=${fileName}`,
    method: "get",
    responseType: 'blob',
  });
}

// 分片文件下载
export function getFileDownloadPart(filePath, startByte, endByte, fileName) {
  return request({
    url: `/base/tool/file/v1/download/part?endByte=${endByte}&fileName=${fileName}&filePath=${filePath}&startByte=${startByte}`,
    method: "get",
  });
}
// 通过userid 获取用户信息
export function getUserInfo(userId) {
  return request({
    url: `/base/user/v1/info?userId=${userId}`,
    method: "get",
  });
}
export function getUserInfoNew(userId) {
  return request({
    url: `/base/system/user/detail?userId=${userId}`,
    method: "get",
  });
}

// 根据code获取学校信息
export function getSchoolInfoCode(code) {
  return request({
    url: `/base/system/tenant/school/hero/get/school/info/by/code?code=${code}`,
    method: "get",
  });
}

// 用户申请绑定学校
export function applyBindSchool(schoolId, userId) {
  return request({
    url: `/base/system/user/user/apply/bind/school?schoolId=${schoolId}&userId=${userId}`,
    method: "post",
  });
}
// 修改个人信息
export function updateUserInfo(data) {
  return request({
    url: `/base/user/v1/update/info`,
    method: "post",
    data: data,
  });
}
// 个人信息 修改密码
export function modifyPassword(data) {
  return request({
    url: `/base/user/v1/update/pwd`,
    method: "post",
    data: data,
  });
}
// 根据个人信息头像文件id 获取文件地址
export function getUserfileimg(fileId) {
  return request({
    url: `/base/tool/file/v1/get/info/of/id?fileId=${fileId}`,
    method: "get",
  });
}

// 分页查询学院列表
export function getBaseDepartmentPage(data) {
  return request({
    url: `/base/dept/v1/departmentPage`,
    method: "post",
    data: data,
  });
}

// 课程分页
export function getBaseCoursePage(data) {
  return request({
    url: `/base/course/v1/page`,
    method: "post",
    data: data,
  });
}

// 简单文件上传  
export function SimpleBaseFileUpload(data) {
  return request({
    url: "/base/tool/file/v1/simple/upload",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data,
  });
}
// MP3 文件下载 
export function filedown(data) {
  return request({
    url: "/base/tool/file/download",
    method: "post",
    responseType: 'blob',
    data: data,
  });
}

// 获取用户角色名称
export function getRolesByUserId() {
  return request({
    url: `/app/zhkt/role/v1/getRolesByUserId`,
    method: "get",
  });
}

// 获取用户角色名称
export function isAdmin() {
  return request({
    url: `/app/zhkt/role/v1/isAdmin`,
    method: "get",
  });
}



// 服务器管理 内外网
export function getExternalInfo(data) {
  return request({
    url: `/base/servermanager/v1/hero/getExternalInfo`,
    method: "get"
  });
}


